import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import styled, { createGlobalStyle } from 'styled-components';
import Action, { icons, colors } from './components/Action';
import Docker from './components/Docker';
import Workflow from './components/Workflow';
import 'bootstrap/dist/css/bootstrap.min.css';

const GlobalStyle = createGlobalStyle`
  pre {
    font-size: 12px !important;
  }
`;

const Wrapper = styled.div`
  max-width: 840px;
  margin: 0 auto;
  padding: 25px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 25px;

  @media only screen and (max-width: 840px) {
    display: block;

    & > div {
      width: auto;
      max-width: 100%;
      margin: 0;
    }
  }
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 35px;
  
  h1 {
    font-weight: bold;
  }

  p {
    margin-bottom: 10px;
  }

  @media only screen and (max-width: 840px) {
    h1 {
      font-size: 2em;
    }

    p {
      font-size: 14px;
    }
  }
`;

const Settings = styled.div`
  width: 50%;
  margin-right: 25px;
`;

const Preview = styled.div`
  max-width: 50%;
  margin-left: 25px;

  & > div {
    margin-bottom: 25px;
  }

  & > div:last-child {
    margin-bottom: 0
  }
`;

const Footer = styled.footer`
  text-align: center;
  margin-top: 25px;
`;

class App extends Component {
  constructor(props) { 
    super(props)
    this.state = {
      name: 'My cool action',
      description: 'Actions are fun',
      icon: icons[0],
      color: 'white',
      repo: 'https://github.com/actions/bin',
    }
  }

  onFieldChange = (value, field) => {
    this.setState({
      [field]: value,
    })
  }

  render() {
    const { name, description, icon, color, repo } = this.state;
    return (
      <div>
        <GlobalStyle />
        <Wrapper>
          <Header>
            <h1>Create GitHub Action</h1>
            <p>
              Preview what a GitHub Action will look like in a workflow, and
              generate the Dockerfile to do so.
            </p>
            <p>
              Check out the official docs for GitHub Actions{" "}
              <a href="https://developer.github.com/actions/">here.</a>
            </p>
          </Header>
          <Container>
            <Settings>
              <h4>Settings</h4>
              <Form>
                <Form.Group controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={name}
                    onChange={e =>
                      this.onFieldChange(e.target.value, "name")
                    }
                  />
                </Form.Group>
                <Form.Group controlId="description">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    value={description}
                    onChange={e =>
                      this.onFieldChange(e.target.value, "description")
                    }
                  />
                </Form.Group>
                <Form.Group controlId="repo">
                  <Form.Label>Repository</Form.Label>
                  <Form.Control
                    type="url"
                    value={repo}
                    onChange={e =>
                      this.onFieldChange(e.target.value, "repo")
                    }
                  />
                </Form.Group>
                <Form.Group controlId="icon">
                  <Form.Label>Icon</Form.Label>
                  <Form.Control
                    as="select"
                    value={icon}
                    onChange={e =>
                      this.onFieldChange(e.target.value, "icon")
                    }
                  >
                    {icons &&
                      icons.map(i => <option value={i}>{i}</option>)}
                  </Form.Control>
                </Form.Group>
                <Form.Group controlId="color">
                  <Form.Label>Color</Form.Label>
                  <Form.Control
                    as="select"
                    value={color}
                    onChange={e =>
                      this.onFieldChange(e.target.value, "color")
                    }
                  >
                    {colors &&
                      Object.keys(colors).map(c => (
                        <option value={c}>{c}</option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Form>
            </Settings>
            <Preview>
              <div>
                <h4>Action Preview</h4>
                <Action name={name} color={color} icon={icon} repo={repo} />
              </div>
              <div>
                <h4>main.workflow</h4>
                <Workflow name={name} repo={repo} />
              </div>
              <div>
                <h4>Dockerfile</h4>
                <Docker
                  name={name}
                  description={description}
                  icon={icon}
                  color={color}
                  repo={repo}
                />
              </div>
            </Preview>
          </Container>
          <Footer>
            Built by{" "}
            <a href="https://twitter.com/stevekaliski">Steve Kaliski</a>
          </Footer>
        </Wrapper>
      </div>
    );
  }
}

export default App;
